import $ from 'jquery';

export default class Accordion {
  constructor($el, options = {}) {
    this.$el = $el;

    this.options = $.extend({}, {
      activeClass: 'accordion--active',
      autoCollapse: false,
      content: '[data-accordion-content]',
      eligibleClass: 'has-accordion',
    }, options);
  }

  toggle($block, open = false) {
    if (open || !$block.hasClass(this.options.activeClass)) {
      if (this.options.autoCollapse) this.closeOpen();
      this._open($block);
    } else {
      this._close($block);
    }
  }

  closeOpen() {
    $(this.$el.find(`.${this.options.activeClass}`)).each((i, block) => {
      const $block = $(block);
      if ($block.hasClass(this.options.activeClass)) {
        this._close($block);
      }
    });
  }

  openAll() {
    $(this.$el.find(`.${this.options.eligibleClass}`)).each((i, block) => {
      this._open($(block), 0);
    });
  }

  _open($block) {
    $block.addClass(this.options.activeClass);
  }

  _close($block) {
    $block.removeClass(this.options.activeClass);
  }
}
